import { supabase } from '../lib/supabase';

const nodeTypeService = {
  /**
   * Get all node types (system and custom)
   */
  async getAllNodeTypes() {
    const { data, error } = await supabase?.from('node_types')?.select('*')?.order('is_system', { ascending: false })?.order('type_label', { ascending: true });

    if (error) {
      console.error('Error fetching node types:', error);
      throw new Error(error?.message || 'Failed to fetch node types');
    }

    return data || [];
  },

  /**
   * Create a new custom node type
   */
  async createNodeType({ typeValue, typeLabel, userId }) {
    const { data: { user } } = await supabase?.auth?.getUser();
    
    const { data, error } = await supabase?.from('node_types')?.insert([{
        type_value: typeValue,
        type_label: typeLabel,
        user_id: user?.id || null,
        is_system: false
      }])?.select()?.single();

    if (error) {
      console.error('Error creating node type:', error);
      // Check if it's an RLS policy violation (authentication required)
      if (error?.code === '42501' || error?.message?.includes('row-level security')) {
        throw new Error('You must be logged in to create node types');
      }
      throw new Error(error?.message || 'Failed to create node type');
    }

    return data;
  },

  /**
   * Update an existing custom node type
   */
  async updateNodeType(id, { typeLabel }) {
    const { data, error } = await supabase?.from('node_types')?.update({
        type_label: typeLabel,
        updated_at: new Date()?.toISOString()
      })?.eq('id', id)?.select()?.single();

    if (error) {
      console.error('Error updating node type:', error);
      throw new Error(error?.message || 'Failed to update node type');
    }

    return data;
  },

  /**
   * Delete a custom node type
   */
  async deleteNodeType(id) {
    const { error } = await supabase?.from('node_types')?.delete()?.eq('id', id);

    if (error) {
      console.error('Error deleting node type:', error);
      throw new Error(error?.message || 'Failed to delete node type');
    }

    return true;
  },

  /**
   * Delete all custom node types for the current user
   */
  async deleteAllCustomNodeTypes(user) {
    if (!user?.id) {
      throw new Error('User ID is required');
    }

    // Delete all node types that belong to the current user (including system types)
    const { data, error, count } = await supabase
      ?.from('node_types')
      ?.delete({ count: 'exact' })
      ?.eq('user_id', user?.id)
      ?.select();

    if (error) {
      console.error('Error deleting node types:', error);
      throw new Error(error?.message || 'Failed to delete node types');
    }

    return count || 0;
  }
};

export default nodeTypeService;